import React from 'react';
import { LoadingFlyer } from 'splash/components';

const FlyerRoute = (props) => <LoadingFlyer {...props} />;

export default FlyerRoute;
